import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Table,
  Message,
  Icon,
  Dropdown,
  Dimmer,
  Loader,
  Pagination,
  Form,
  Checkbox,
  Modal,
  Label,
  Header,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  getOutletsAction,
  updateOutletSubcriptionsAction,
} from 'state/business/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';
import DatePicker from 'components/DatePicker';
import { endOfDay } from 'date-fns';
import styles from './OutletAction.module.css';

const mapStateToPropsOutletAction = ({ business }) => ({
  outlets: business.outlets,
  loadingOutlets: business.loadingOutlets,
  allBusiness: business.allBusiness,
});

const OutletAction = connect(mapStateToPropsOutletAction)(props => {
  const { dispatch, outlets, allBusiness, loadingOutlets } = props;
  const currBusinessId = allBusiness.data[allBusiness.activeIndex].id;

  const [actionState, setActionState] = useState({});
  const [emptyExpirationErrorFlag, setEmptyExpirationErrorFlag] = useState(
    false
  );
  const [emptyReasonErrorFlag, setEmptyReasonErrorFlag] = useState(false);
  const [noSelectedOutletErrorFlag, setNoSelectedOutletErrorFlag] = useState(
    false
  );
  const [
    outletNotSubscribingErrorFlag,
    setOutletNotSubscribingErrorFlag,
  ] = useState(false);
  const [outletExpirationModal, setOutletExpirationModal] = useState(false);
  const [outletSubscriptionModal, setOutletSubscriptionModal] = useState({
    startSub: {
      isOpen: false,
      outlet: null,
    },
    stopSub: {
      isOpen: false,
      outlet: null,
    },
  });

  useEffect(() => {
    const payload = {
      businessId: currBusinessId,
      page: 1,
      size: 10,
    };
    dispatch(getOutletsAction(payload));
  }, [currBusinessId, dispatch]);

  useEffect(() => {
    const outletsSelectedStatus = {};
    if (outlets.data) {
      for (let i = 0; i < outlets.data.outlets.length; i++) {
        const outletId = parseInt(outlets.data.outlets[i].id, 10);
        outletsSelectedStatus[outletId] = false;
      }
    }

    const initialState = {
      newBillingCycle: {
        key: 'Keep the same billing cycle',
        text: 'Keep the same billing cycle',
        value: 'Keep the same billing cycle',
      },
      newExpirationDate: null,
      reason: '',
      outletsSelectedStatus,
    };
    setActionState(initialState);
  }, [allBusiness.activeIndex, allBusiness.data, dispatch, outlets]);

  let paging = null;
  if (outlets) {
    paging = outlets.paging;
  }
  let totalPages = 0;
  if (paging) totalPages = Math.ceil(paging.total / paging.size);

  const handleOnPageChange = (_, val) => {
    const { activePage } = val;
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      page: activePage,
      size: 10,
    };
    setNoSelectedOutletErrorFlag(false);
    setEmptyExpirationErrorFlag(false);
    setEmptyReasonErrorFlag(false);
    setOutletNotSubscribingErrorFlag(false);
    dispatch(getOutletsAction(payload));
  };

  const paymentStatusOptions = [
    {
      key: 'Keep the same billing cycle',
      text: 'Keep the same billing cycle',
      value: 'Keep the same billing cycle',
    },
    {
      key: 'Moka 12 Months',
      text: 'Moka 12 Months',
      value: 'Moka 12 Months',
    },
    {
      key: 'Moka Monthly',
      text: 'Moka Monthly',
      value: 'Moka Monthly',
    },
  ];

  const handleNewBillingCycleChange = (e, { value }) => {
    const newBillingCycle = paymentStatusOptions.find(
      status => status.key === value
    );
    setActionState({ ...actionState, newBillingCycle });
  };

  const handleNewExpirationDateChange = date => {
    setActionState({
      ...actionState,
      newExpirationDate: date ? endOfDay(date) : null,
    });
    setEmptyExpirationErrorFlag(false);
  };

  const handleReasonChange = e => {
    setActionState({
      ...actionState,
      reason: e.target.value,
    });
    setEmptyReasonErrorFlag(false);
  };

  const checkSelectedAll = () => {
    const cntUnselected = Object.keys(actionState.outletsSelectedStatus).filter(
      id => actionState.outletsSelectedStatus[id] === false
    ).length;

    return cntUnselected === 0;
  };

  const handleSelectAll = () => {
    if (checkSelectedAll()) {
      setActionState({
        ...actionState,
        outletsSelectedStatus: (() => {
          const newStatus = {};
          Object.keys(actionState.outletsSelectedStatus).forEach(id => {
            newStatus[id] = false;
          });
          return newStatus;
        })(),
      });
    } else {
      setActionState({
        ...actionState,
        outletsSelectedStatus: (() => {
          const newStatus = {};
          Object.keys(actionState.outletsSelectedStatus).forEach(id => {
            newStatus[id] = true;
          });
          return newStatus;
        })(),
      });
      setNoSelectedOutletErrorFlag(false);
    }
  };

  const handleSelectAnOutlet = outlet => {
    const outletId = parseInt(outlet.id, 10);
    const currStatus = actionState.outletsSelectedStatus[outletId];

    setActionState({
      ...actionState,
      outletsSelectedStatus: {
        ...actionState.outletsSelectedStatus,
        [outletId]: !currStatus,
      },
    });
    setNoSelectedOutletErrorFlag(false);
  };

  const handleSubmitOutletActionButton = () => {
    const payload = {
      businessId: currBusinessId,
      new_billing_cycle:
        actionState.newBillingCycle.value === 'Keep the same billing cycle'
          ? ''
          : actionState.newBillingCycle.value,
      new_date: actionState.newExpirationDate,
      reason: actionState.reason,
      outlet_ids: (() => {
        const checkedOutlets = Object.keys(
          actionState.outletsSelectedStatus
        ).filter(id => actionState.outletsSelectedStatus[id] === true);
        return checkedOutlets.map(key => parseInt(key, 10));
      })(),
    };
    setOutletExpirationModal(false);
    dispatch(updateOutletSubcriptionsAction(payload));
  };

  const getAllCheckedOutlets = () => {
    const checkedOutlets = Object.keys(
      actionState.outletsSelectedStatus
    ).filter(id => actionState.outletsSelectedStatus[id] === true);

    return checkedOutlets;
  };

  const isNotSubscribingOutletChecked = () => {
    for (let i = 0; i < outlets.data.outlets.length; i++) {
      const outlet = outlets.data.outlets[i];
      if (
        actionState.outletsSelectedStatus[outlet.id] &&
        !outlet.is_active_subscription
      ) {
        return true;
      }
    }
    return false;
  };

  const checkIsOkToSubmit = () => {
    const checkedOutlets = getAllCheckedOutlets();
    const { newBillingCycle, newExpirationDate, reason } = actionState;
    return (
      newBillingCycle &&
      newExpirationDate &&
      reason &&
      checkedOutlets.length > 0 &&
      !isNotSubscribingOutletChecked()
    );
  };
  const convertDate = payloadDate => {
    const dateTimeFormat = new Intl.DateTimeFormat('id', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const date = new Date(payloadDate);
    return dateTimeFormat.format(date);
  };
  const handleOpenStartSubModal = outlet => {
    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      startSub: {
        isOpen: true,
        outlet,
      },
    });
    setNoSelectedOutletErrorFlag(false);
    setEmptyExpirationErrorFlag(false);
    setOutletNotSubscribingErrorFlag(false);
  };
  const handleCloseStartSubModal = () => {
    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      startSub: {
        isOpen: false,
        outlet: null,
      },
    });
  };
  const handleStartSub = () => {
    const payload = {
      businessId: currBusinessId,
      new_billing_cycle:
        actionState.newBillingCycle.value === 'Keep the same billing cycle'
          ? ''
          : actionState.newBillingCycle.value,
      outlet_ids: [outletSubscriptionModal.startSub.outlet.id],
      new_date: allBusiness.data[allBusiness.activeIndex].expired_at,
      is_active_subscription: true,
    };
    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      startSub: {
        isOpen: false,
        outlet: null,
      },
    });
    dispatch(updateOutletSubcriptionsAction(payload));
  };
  const handleOpenStopSubModal = outlet => {
    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      stopSub: {
        isOpen: true,
        outlet,
      },
    });
    setNoSelectedOutletErrorFlag(false);
    setEmptyExpirationErrorFlag(false);
    setOutletNotSubscribingErrorFlag(false);
  };
  const handleStopSub = () => {
    const payload = {
      businessId: currBusinessId,
      new_billing_cycle:
        actionState.newBillingCycle.value === 'Keep the same billing cycle'
          ? ''
          : actionState.newBillingCycle.value,
      outlet_ids: [outletSubscriptionModal.stopSub.outlet.id],
      is_active_subscription: false,
    };

    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      stopSub: {
        isOpen: false,
        outlet: null,
      },
    });
    dispatch(updateOutletSubcriptionsAction(payload));
  };
  const handleCloseStopSubModal = () => {
    setOutletSubscriptionModal({
      ...outletSubscriptionModal,
      stopSub: {
        isOpen: false,
        outlet: null,
      },
    });
  };
  const handleOpenOutletExpirationModal = () => {
    const checkedOutlets = getAllCheckedOutlets();
    const { newExpirationDate, reason } = actionState;

    setOutletNotSubscribingErrorFlag(false);
    setEmptyExpirationErrorFlag(false);
    setEmptyReasonErrorFlag(false);
    setNoSelectedOutletErrorFlag(false);

    if (isNotSubscribingOutletChecked()) {
      setOutletNotSubscribingErrorFlag(true);
    }
    if (!newExpirationDate) {
      setEmptyExpirationErrorFlag(true);
    }
    if (!reason) {
      setEmptyReasonErrorFlag(true);
    }
    if (!checkedOutlets.length > 0) {
      setNoSelectedOutletErrorFlag(true);
    }
    if (checkIsOkToSubmit()) {
      setOutletExpirationModal(true);
    }
  };
  const handleCloseOutletExpirationModal = () => {
    setOutletExpirationModal(false);
  };

  return (
    <div className={styles['outlet-action-container']}>
      <SemanticToastContainer />
      {/* stop subscription modal */}
      <Modal size="small" open={outletSubscriptionModal.stopSub.isOpen}>
        <div className={styles['stop-subscription-header']}>
          <Header>
            <div className={styles['stop-subscription-header-content']}>
              <strong>Confirm</strong>
            </div>
          </Header>
        </div>
        <Modal.Content>
          <p>
            Are you sure you want to stop{' '}
            <strong>
              {outletSubscriptionModal.stopSub.outlet
                ? outletSubscriptionModal.stopSub.outlet.name
                : ''}{' '}
            </strong>
            subscription?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleCloseStopSubModal}>
            <div className={styles['stop-subscription-cancel-button-content']}>
              Cancel
            </div>
          </Button>
          <Button onClick={handleStopSub} color="red">
            <div className={styles['stop-subscription-update-button-content']}>
              Update
            </div>
          </Button>
        </Modal.Actions>
      </Modal>
      {/* start subscription modal */}
      <Modal size="small" open={outletSubscriptionModal.startSub.isOpen}>
        <div className={styles['start-subscription-header']}>
          <Header>
            <div className={styles['start-subscription-header-content']}>
              <strong>Confirm</strong>
            </div>
          </Header>
        </div>
        <Modal.Content>
          <p>
            Are you sure you want to start{' '}
            <strong>
              {outletSubscriptionModal.startSub.outlet
                ? outletSubscriptionModal.startSub.outlet.name
                : ''}{' '}
            </strong>
            subscription with expired date:{' '}
            <strong>
              {convertDate(
                allBusiness.data[allBusiness.activeIndex].expired_at
              )}
            </strong>{' '}
            ?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleCloseStartSubModal}>
            <div className={styles['start-subscription-cancel-button-content']}>
              Cancel
            </div>
          </Button>
          <Button onClick={handleStartSub} color="blue">
            <div className={styles['start-subscription-update-button-content']}>
              Update
            </div>
          </Button>
        </Modal.Actions>
      </Modal>
      {/* outlet expiration modal */}
      <Modal size="small" open={outletExpirationModal}>
        <div className={styles['outlet-expiration-header']}>
          <Header>
            <div className={styles['outlet-expiration-header-content']}>
              <strong>Confirm</strong>
            </div>
          </Header>
        </div>
        <Modal.Content>
          <p>
            Are you sure you want to change expiration date to:{' '}
            <strong>
              {actionState.newExpirationDate
                ? convertDate(actionState.newExpirationDate)
                : ''}
            </strong>
            ?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleCloseOutletExpirationModal}>
            <div className={styles['outlet-expiration-cancel-button-content']}>
              Cancel
            </div>
          </Button>
          <Button onClick={handleSubmitOutletActionButton} color="red">
            <div className={styles['outlet-expiration-update-button-content']}>
              Update
            </div>
          </Button>
        </Modal.Actions>
      </Modal>
      <Message warning>
        <Icon name="warning sign" />
        <span>
          {' '}
          <strong>WARNING:</strong> The time difference between Outlets must be
          1 month, 12 months, or the same!
        </span>
      </Message>
      <Form>
        <Grid>
          <Grid.Column width="7">
            <label htmlFor="billing-cycle-dropdown">
              <strong>New Billing Cycle</strong>
            </label>
            <Dropdown
              id="billing-cycle-dropdown"
              value={
                actionState.newBillingCycle
                  ? actionState.newBillingCycle.key
                  : 'Keep the same billing cycle'
              }
              options={paymentStatusOptions}
              fluid
              selection
              onChange={handleNewBillingCycleChange}
            />
          </Grid.Column>
          <Grid.Column width="7">
            <label htmlFor="new-expiration-date">
              <strong>New Expiration Date</strong>
            </label>
            <DatePicker
              id="new-expiration-date"
              onChange={handleNewExpirationDateChange}
              selected={actionState.newExpirationDate}
              isClearable
            />
            {emptyExpirationErrorFlag && (
              <Label basic color="red" pointing>
                Please enter a new expiration date
              </Label>
            )}
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column width="7">
            <label htmlFor="reason">
              <strong>Reason</strong>
            </label>
            <Form.TextArea
              id="reason"
              name="reason"
              value={actionState.reason || ''}
              onChange={handleReasonChange}
            />
            {emptyReasonErrorFlag && (
              <Label basic color="red" pointing>
                Please enter a reason
              </Label>
            )}
          </Grid.Column>
        </Grid>
      </Form>
      <br />
      {Object.keys(actionState).length !== 0 ? (
        <>
          <div className={styles['outlet-list-segment']}>
            <Dimmer active={loadingOutlets}>
              <Loader size="massive">Loading</Loader>
            </Dimmer>
            <Table celled selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell onClick={handleSelectAll}>
                    <div className={styles['select-unselect-all']}>
                      {checkSelectedAll() ? 'Unselect All' : 'Select All'}
                    </div>
                  </Table.HeaderCell>
                  <Table.HeaderCell>ID</Table.HeaderCell>
                  <Table.HeaderCell>Outlet Name</Table.HeaderCell>
                  <Table.HeaderCell>Expired Date</Table.HeaderCell>
                  <Table.HeaderCell>Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {outlets.data ? (
                  outlets.data.outlets.map(outlet => {
                    let keys = '';
                    Object.keys(outlet).forEach(key => {
                      keys += outlet[key];
                    });
                    return (
                      <Table.Row key={keys}>
                        <Table.Cell>
                          <Checkbox
                            checked={
                              actionState.outletsSelectedStatus[outlet.id]
                            }
                            onClick={() => handleSelectAnOutlet(outlet)}
                          />
                        </Table.Cell>
                        <Table.Cell key={`${keys}ID`}>{outlet.id}</Table.Cell>
                        <Table.Cell key={`${keys}name`}>
                          {outlet.name}
                          {actionState.outletsSelectedStatus[outlet.id] &&
                            outletNotSubscribingErrorFlag &&
                            !outlet.is_active_subscription && (
                              <p>
                                <strong
                                  className={
                                    styles['not-subscribing-error-content']
                                  }
                                >
                                  Please click &ldquo;Start Subscription&rdquo;
                                  first to continue extending expired date.
                                </strong>
                              </p>
                            )}
                        </Table.Cell>
                        <Table.Cell key={`${keys}expiredAt`}>
                          {convertDate(outlet.end_date)}
                        </Table.Cell>
                        <Table.Cell key={`${keys}action`}>
                          {outlet.is_active_subscription ? (
                            <Button
                              color="orange"
                              onClick={() => handleOpenStopSubModal(outlet)}
                            >
                              Stop Subscription
                            </Button>
                          ) : (
                            <Button
                              color="green"
                              onClick={() => handleOpenStartSubModal(outlet)}
                            >
                              Start Subscription
                            </Button>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })
                ) : (
                  <></>
                )}
              </Table.Body>
              {paging ? (
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="7">
                      <Pagination
                        activePage={paging.page}
                        totalPages={totalPages}
                        onPageChange={handleOnPageChange}
                        size="mini"
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              ) : (
                <></>
              )}
            </Table>
          </div>
          {noSelectedOutletErrorFlag && (
            <Label basic color="red" pointing>
              Please select outlet
            </Label>
          )}
          {outletNotSubscribingErrorFlag && (
            <Label basic color="red" pointing>
              Please check selected outlets
            </Label>
          )}
        </>
      ) : (
        <></>
      )}
      <Button
        type="button"
        floated="right"
        color="blue"
        onClick={handleOpenOutletExpirationModal}
      >
        Submit
      </Button>
      <br />
    </div>
  );
});

OutletAction.propTypes = {
  dispatch: PropTypes.func.isRequired,
  outlets: PropTypes.object.isRequired,
  loadingOutlets: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
};

export default OutletAction;
